import gql from 'graphql-tag';

export const addVstupniPole = gql`
  mutation addVstupniPole($input: [VstupniPoleInput!]!) {
    response: addVstupniPole(inputVstupniPole: $input) {
      id
    }
  }
`;
